// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-selection-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
}

.label-selection-modal {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.label-selection-modal-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  color: #333;
}

.label-selection-options {
  margin-bottom: 20px;
}

.label-selection-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.label-selection-option input {
  width: 16px;
  height: 16px;
  accent-color: var(--primary-color, #004A9A);
  margin-right: 8px;
}

.label-selection-desc {
  font-size: 14px;
  color: #666;
  margin-left: 24px;
  line-height: 1.4;
  margin-top: 8px;
  margin-bottom: 12px;
}

.existing-labels-section {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8f9fa;
  position: relative;
}

.search-container {
  margin-bottom: 15px;
}

.dropdown-container {
  margin-bottom: 15px;
}

.dropdown-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.label-dropdown {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  cursor: pointer;
}
.label-dropdown:focus {
  outline: none;
  border-color: var(--primary-color, #004A9A);
  box-shadow: 0 0 0 2px rgba(0, 74, 154, 0.2);
}
.label-dropdown:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}
.label-dropdown option {
  padding: 8px;
}

.label-search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}
.label-search-input:focus {
  outline: none;
  border-color: var(--primary-color, #004A9A);
  box-shadow: 0 0 0 2px rgba(0, 74, 154, 0.2);
}

.loading-container {
  text-align: center;
  padding: 20px;
  color: #666;
  font-style: italic;
}

.labels-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.label-item {
  display: flex;
  align-items: flex-start;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}
.label-item:hover {
  border-color: var(--primary-color, #004A9A);
  background-color: #f8f9ff;
}
.label-item input[type=checkbox] {
  margin-right: 12px;
  margin-top: 2px;
  width: 16px;
  height: 16px;
  accent-color: var(--primary-color, #004A9A);
}

.label-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label-name-color {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label-name {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.label-color-indicator {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.label-description {
  font-size: 12px;
  color: #666;
  line-height: 1.3;
}

.label-priority {
  font-size: 11px;
  color: #888;
  font-weight: 500;
}

.no-labels-message {
  text-align: center;
  color: #666;
  font-style: italic;
  padding: 20px;
}

.selected-count {
  margin-top: 15px;
  padding: 10px 15px;
  background: linear-gradient(135deg, var(--primary-color, #004A9A) 0%, #0066cc 100%);
  color: white;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 74, 154, 0.2);
}

.selected-labels-container {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background-color: #f8fafc;
}

.selected-labels-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.selected-labels-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.selected-label-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}
.selected-label-item:hover {
  border-color: #9ca3af;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.selected-label-item .label-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}
.selected-label-item .label-info .label-name {
  font-weight: 500;
  color: #111827;
  font-size: 14px;
  line-height: 1.4;
}
.selected-label-item .label-info .label-description {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.3;
  font-style: italic;
}

.remove-label-btn {
  background: grey;
  color: white;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.remove-label-btn:hover {
  transform: scale(1.05);
}
.remove-label-btn:active {
  transform: scale(0.95);
}

/* Searchable Dropdown Styles */
.searchable-dropdown-container {
  margin-bottom: 20px;
  position: relative;
}
.searchable-dropdown-container .dropdown-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}
.searchable-dropdown-container .searchable-dropdown {
  position: relative;
  /* Add smooth scrolling */
}
.searchable-dropdown-container .searchable-dropdown * {
  scroll-behavior: smooth;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container {
  display: flex;
  border: 2px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  background: white;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container:focus-within {
  border-color: var(--primary-color, #004A9A);
  box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);
}
.searchable-dropdown-container .searchable-dropdown .search-input-container:hover {
  border-color: #bbb;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .search-input {
  flex: 1 1;
  padding: 12px;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .search-input::placeholder {
  color: #999;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .search-input:disabled {
  background: #f5f5f5;
  color: #999;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .dropdown-toggle-btn {
  padding: 12px 16px;
  border: none;
  border-left: 1px solid #ddd;
  background: #f8f9fa;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .dropdown-toggle-btn:hover:not(:disabled) {
  background: #e9ecef;
  color: #333;
}
.searchable-dropdown-container .searchable-dropdown .search-input-container .dropdown-toggle-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  border: 2px solid #ddd;
  border-top: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  margin-top: 2px;
  /* Custom scrollbar styling */
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::-webkit-scrollbar {
  width: 8px;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0 4px 4px 0;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options {
  /* Fade effect for overflow indication */
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options::after {
  content: "";
  position: sticky;
  bottom: 0;
  height: 10px;
  background: linear-gradient(transparent, rgba(255, 255, 255, 0.8));
  pointer-events: none;
  display: block;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options {
  /* Show scroll indicator shadow when scrollable */
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options.has-scroll {
  border-bottom: 3px solid #e0e0e0;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options.has-scroll::before {
  content: "";
  position: sticky;
  top: 0;
  height: 5px;
  background: linear-gradient(rgba(255, 255, 255, 0.8), transparent);
  pointer-events: none;
  display: block;
  z-index: 1;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option {
  padding: 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
  background: white;
  min-height: 60px;
  flex-shrink: 0;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option:first-child {
  border-radius: 6px 6px 0 0;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option:last-child {
  border-bottom: none;
  border-radius: 0 0 6px 6px;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option:hover:not(.loading-option):not(.no-results-option) {
  background: #f8f9ff;
  border-left: 3px solid var(--primary-color, #004A9A);
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option.selected {
  background: #e3f2fd;
  color: #1976d2;
  border-left: 3px solid #1976d2;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option.loading-option, .searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option.no-results-option {
  color: #999;
  cursor: default;
  font-style: italic;
  justify-content: center;
  background: #f9f9f9;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option .option-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option .option-content .option-name {
  font-weight: 500;
  color: #333;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option .option-content .option-description {
  font-size: 0.875rem;
  color: #666;
}
.searchable-dropdown-container .searchable-dropdown .dropdown-options .dropdown-option .selected-indicator {
  color: #4caf50;
  font-weight: bold;
  font-size: 16px;
}

.label-selection-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
}

.btn-cancel {
  padding: 8px 16px;
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}
.btn-cancel:hover {
  background: #e5e5e5;
  border-color: #bbb;
}

.btn-primary {
  padding: 8px 16px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}
.btn-primary:hover:not(:disabled) {
  background: #005a9a;
}
.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/LabelSelectionModal/LabelSelectionModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,iBAAA;AACJ;;AAGA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;AAAF;AAEE;EACE,aAAA;EACA,2CAAA;EACA,2CAAA;AAAJ;AAGE;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAIE;EACE,YAAA;AAFJ;;AAMA;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAHF;AAKE;EACE,aAAA;EACA,2CAAA;EACA,2CAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAJF;AAME;EACE,2CAAA;EACA,yBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;AALJ;;AASA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANF;;AASA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AANF;;AASA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AANF;;AASA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AANF;;AASA;EACE,gBAAA;EACA,kBAAA;EACA,mFAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;AANF;;AASA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AANF;;AASA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yCAAA;EACA,yBAAA;AANF;AAQE;EACE,qBAAA;EACA,wCAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;AAPJ;AASI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAPN;AAUI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AARN;;AAaA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AAVF;AAYE;EAEE,sBAAA;AAXJ;AAcE;EACE,sBAAA;AAZJ;;AAgBA,+BAAA;AACA;EACE,mBAAA;EACA,kBAAA;AAbF;AAeE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAbJ;AAgBE;EACE,kBAAA;EAEA,yBAAA;AAfJ;AAgBI;EACE,uBAAA;AAdN;AAiBI;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAfN;AAiBM;EACE,2CAAA;EACA,2CAAA;AAfR;AAkBM;EACE,kBAAA;AAhBR;AAmBM;EACE,SAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AAjBR;AAmBQ;EACE,WAAA;AAjBV;AAoBQ;EACE,mBAAA;EACA,WAAA;AAlBV;AAsBM;EACE,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AApBR;AAsBQ;EACE,mBAAA;EACA,WAAA;AApBV;AAuBQ;EACE,mBAAA;EACA,YAAA;AArBV;AA0BI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,eAAA;EAEA,6BAAA;AAzBN;AA0BM;EACE,UAAA;AAxBR;AA2BM;EACE,mBAAA;EACA,0BAAA;AAzBR;AA4BM;EACE,mBAAA;EACA,kBAAA;AA1BR;AA4BQ;EACE,mBAAA;AA1BV;AALI;EAmCE,wCAAA;AA3BN;AA4BM;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,kEAAA;EACA,oBAAA;EACA,cAAA;AA1BR;AAjBI;EA8CE,iDAAA;AA1BN;AA2BM;EACE,gCAAA;AAzBR;AA2BQ;EACE,WAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,kEAAA;EACA,oBAAA;EACA,cAAA;EACA,UAAA;AAzBV;AA6BM;EACE,aAAA;EACA,eAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AA3BR;AA8BQ;EACE,0BAAA;AA5BV;AA+BQ;EACE,mBAAA;EACA,0BAAA;AA7BV;AAgCQ;EACE,mBAAA;EACA,oDAAA;AA9BV;AAiCQ;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AA/BV;AAkCQ;EAEE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAjCV;AAoCQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;AAlCV;AAoCU;EACE,gBAAA;EACA,WAAA;AAlCZ;AAqCU;EACE,mBAAA;EACA,WAAA;AAnCZ;AAuCQ;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AArCV;;AA4CA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAzCF;;AA4CA;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAzCF;AA2CE;EACE,mBAAA;EACA,kBAAA;AAzCJ;;AA6CA;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA1CF;AA4CE;EACE,mBAAA;AA1CJ;AA6CE;EACE,YAAA;EACA,mBAAA;AA3CJ","sourcesContent":[".label-selection-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9998;\n}\n\n.label-selection-modal {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.label-selection-modal-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  text-align: center;\n  color: #333;\n}\n\n.label-selection-options {\n  margin-bottom: 20px;\n}\n\n.label-selection-option {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 8px;\n\n  input {\n    width: 16px;\n    height: 16px;\n    accent-color: var(--primary-color, #004A9A);\n    margin-right: 8px;\n  }\n}\n\n.label-selection-desc {\n  font-size: 14px;\n  color: #666;\n  margin-left: 24px;\n  line-height: 1.4;\n  margin-top: 8px;\n  margin-bottom: 12px;\n}\n\n.existing-labels-section {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 15px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n  position: relative;\n}\n\n.search-container {\n  margin-bottom: 15px;\n}\n\n.dropdown-container {\n  margin-bottom: 15px;\n}\n\n.dropdown-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.label-dropdown {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: white;\n  cursor: pointer;\n  \n  &:focus {\n    outline: none;\n    border-color: var(--primary-color, #004A9A);\n    box-shadow: 0 0 0 2px rgba(0, 74, 154, 0.2);\n  }\n\n  &:disabled {\n    background-color: #f5f5f5;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n\n  option {\n    padding: 8px;\n  }\n}\n\n.label-search-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  \n  &:focus {\n    outline: none;\n    border-color: var(--primary-color, #004A9A);\n    box-shadow: 0 0 0 2px rgba(0, 74, 154, 0.2);\n  }\n}\n\n.loading-container {\n  text-align: center;\n  padding: 20px;\n  color: #666;\n  font-style: italic;\n}\n\n.labels-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.label-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  \n  &:hover {\n    border-color: var(--primary-color, #004A9A);\n    background-color: #f8f9ff;\n  }\n\n  input[type=\"checkbox\"] {\n    margin-right: 12px;\n    margin-top: 2px;\n    width: 16px;\n    height: 16px;\n    accent-color: var(--primary-color, #004A9A);\n  }\n}\n\n.label-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.label-name-color {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.label-name {\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.label-color-indicator {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.label-description {\n  font-size: 12px;\n  color: #666;\n  line-height: 1.3;\n}\n\n.label-priority {\n  font-size: 11px;\n  color: #888;\n  font-weight: 500;\n}\n\n.no-labels-message {\n  text-align: center;\n  color: #666;\n  font-style: italic;\n  padding: 20px;\n}\n\n.selected-count {\n  margin-top: 15px;\n  padding: 10px 15px;\n  background: linear-gradient(135deg, var(--primary-color, #004A9A) 0%, #0066cc 100%);\n  color: white;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  box-shadow: 0 2px 4px rgba(0, 74, 154, 0.2);\n}\n\n.selected-labels-container {\n  margin-top: 20px;\n  padding: 15px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background-color: #f8fafc;\n}\n\n.selected-labels-title {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.selected-labels-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.selected-label-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background-color: white;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n\n  &:hover {\n    border-color: #9ca3af;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  .label-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n\n    .label-name {\n      font-weight: 500;\n      color: #111827;\n      font-size: 14px;\n      line-height: 1.4;\n    }\n\n    .label-description {\n      font-size: 12px;\n      color: #6b7280;\n      line-height: 1.3;\n      font-style: italic;\n    }\n  }\n}\n\n.remove-label-btn {\n  background: grey;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n\n  &:hover {\n    //background: #dc2626;\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n}\n\n/* Searchable Dropdown Styles */\n.searchable-dropdown-container {\n  margin-bottom: 20px;\n  position: relative;\n  \n  .dropdown-label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .searchable-dropdown {\n    position: relative;\n    \n    /* Add smooth scrolling */\n    * {\n      scroll-behavior: smooth;\n    }\n    \n    .search-input-container {\n      display: flex;\n      border: 2px solid #ddd;\n      border-radius: 6px;\n      overflow: hidden;\n      background: white;\n      \n      &:focus-within {\n        border-color: var(--primary-color, #004A9A);\n        box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);\n      }\n      \n      &:hover {\n        border-color: #bbb;\n      }\n      \n      .search-input {\n        flex: 1;\n        padding: 12px;\n        border: none;\n        outline: none;\n        font-size: 14px;\n        background: transparent;\n        \n        &::placeholder {\n          color: #999;\n        }\n        \n        &:disabled {\n          background: #f5f5f5;\n          color: #999;\n        }\n      }\n      \n      .dropdown-toggle-btn {\n        padding: 12px 16px;\n        border: none;\n        border-left: 1px solid #ddd;\n        background: #f8f9fa;\n        color: #666;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        \n        &:hover:not(:disabled) {\n          background: #e9ecef;\n          color: #333;\n        }\n        \n        &:disabled {\n          cursor: not-allowed;\n          opacity: 0.5;\n        }\n      }\n    }\n    \n    .dropdown-options {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      right: 0;\n      max-height: 250px;\n      overflow-y: auto;\n      overflow-x: hidden;\n      background: white;\n      border: 2px solid #ddd;\n      border-top: 1px solid #ddd;\n      border-radius: 6px;\n      box-shadow: 0 8px 24px rgba(0,0,0,0.15);\n      z-index: 9999;\n      margin-top: 2px;\n      \n      /* Custom scrollbar styling */\n      &::-webkit-scrollbar {\n        width: 8px;\n      }\n      \n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 0 4px 4px 0;\n      }\n      \n      &::-webkit-scrollbar-thumb {\n        background: #c1c1c1;\n        border-radius: 4px;\n        \n        &:hover {\n          background: #a8a8a8;\n        }\n      }\n      \n      /* Fade effect for overflow indication */\n      &::after {\n        content: '';\n        position: sticky;\n        bottom: 0;\n        height: 10px;\n        background: linear-gradient(transparent, rgba(255,255,255,0.8));\n        pointer-events: none;\n        display: block;\n      }\n      \n      /* Show scroll indicator shadow when scrollable */\n      &.has-scroll {\n        border-bottom: 3px solid #e0e0e0;\n        \n        &::before {\n          content: '';\n          position: sticky;\n          top: 0;\n          height: 5px;\n          background: linear-gradient(rgba(255,255,255,0.8), transparent);\n          pointer-events: none;\n          display: block;\n          z-index: 1;\n        }\n      }\n      \n      .dropdown-option {\n        padding: 16px;\n        cursor: pointer;\n        border-bottom: 1px solid #f0f0f0;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        transition: all 0.2s ease;\n        background: white;\n        min-height: 60px;\n        flex-shrink: 0;\n        \n        \n        &:first-child {\n          border-radius: 6px 6px 0 0;\n        }\n        \n        &:last-child {\n          border-bottom: none;\n          border-radius: 0 0 6px 6px;\n        }\n        \n        &:hover:not(.loading-option):not(.no-results-option) {\n          background: #f8f9ff;\n          border-left: 3px solid var(--primary-color, #004A9A);\n        }\n        \n        &.selected {\n          background: #e3f2fd;\n          color: #1976d2;\n          border-left: 3px solid #1976d2;\n        }\n        \n        &.loading-option,\n        &.no-results-option {\n          color: #999;\n          cursor: default;\n          font-style: italic;\n          justify-content: center;\n          background: #f9f9f9;\n        }\n        \n        .option-content {\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n          flex: 1;\n          \n          .option-name {\n            font-weight: 500;\n            color: #333;\n          }\n          \n          .option-description {\n            font-size: 0.875rem;\n            color: #666;\n          }\n        }\n        \n        .selected-indicator {\n          color: #4caf50;\n          font-weight: bold;\n          font-size: 16px;\n        }\n      }\n    }\n  }\n}\n\n.label-selection-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.btn-cancel {\n  padding: 8px 16px;\n  background: #f5f5f5;\n  color: #666;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #e5e5e5;\n    border-color: #bbb;\n  }\n}\n\n.btn-primary {\n  padding: 8px 16px;\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n\n  &:hover:not(:disabled) {\n    background:  #005a9a;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
